import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { EXAM_CENTERS_CONFIG } from '../../constants';

import mastercard from '../../images/mastercard.svg';
import visa from '../../images/visa.svg';
import cb from '../../images/cb.svg';

const InfoBlock = styled.div`
  font-size: 12px;
  line-height: 1.17;
  letter-spacing: -0.1px;
  color: #9aa1a9;
  margin-bottom: 16px;
  > a {
    color: #4a90e2;
  }
`;

const PaymentIconContainer = styled.div`
  display: flex;
  margin-top: 8px;
  
  ${(props) => !props.isLoggedIn && 'justify-content: center;'}
`;

const PaymentIcon = styled.img`
  width: 35px;
  height: 24px;
  object-fit: contain;
  margin-right: 8px;
  &:last-child {
    margin-right: 0;
  }
`;

class Info extends Component {
  render() {
    const { examCenterType, isLoggedIn } = this.props;
    const currentExamCenter = EXAM_CENTERS_CONFIG[examCenterType];

    return (
      <InfoBlock>
        <span>
          Vous y êtes presque! Munissez-vous de votre carte bleue, vous allez
          être dirigé(e) sur l&apos;espace de paiement de
          {' '}
          {examCenterType}
          .
          {' '}
        </span>
        {examCenterType === 'Codengo' && (
          <a href={currentExamCenter.link.href}>
            {currentExamCenter.link.text}
          </a>
        )}
        <PaymentIconContainer isLoggedIn={isLoggedIn}>
          <PaymentIcon src={mastercard} alt="mastercard" />
          <PaymentIcon src={visa} alt="visa" />
          <PaymentIcon src={cb} alt="cb" />
        </PaymentIconContainer>
      </InfoBlock>
    );
  }
}

Info.propTypes = {
  examCenterType: PropTypes.string,
  isLoggedIn: PropTypes.bool,
};

Info.defaultProps = {
  examCenterType: '',
  isLoggedIn: false,
};

export default Info;
